import React, { Component, Fragment } from 'react';
import Modal from 'react-modal';
import customStylesModal from './CustomStylesModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import isWindow from 'components/common/helpers/isWindow';

class BookingModal extends Component {

  state = {
    showModal: false
  }
  componentDidMount() {
    if(isWindow){
      Modal.setAppElement('#root');
    }
  }

  toggleModal = () => {
    this.setState({ showModal: !this.state.showModal }, () => {
      if (!this.state.showModal) {

        if (this.props.callbackChangeStateLp) {
          this.props.callbackChangeStateLp();
        }
      }
    });
  }

  render() {
    const { showModal } = this.state;
    const { children, title, label, modalStyles, calendarModal } = this.props;
    return (
      <Fragment>
        <Modal
          aria={{
            labelledby: label,
          }}
          closeTimeoutMS={100}
          contentLabel={label}
          isOpen={showModal}
          onRequestClose={this.toggleModal}
          overlayClassName="Overlay"
          style={customStylesModal}
        >

          <div className="md-modal__wrap">
            <div className="md-modal__header">
              <button className="button button--text button--icon button--back" onClick={this.toggleModal}>
                <FontAwesomeIcon
                  icon={['fas', 'angle-left']}
                  size="lg"
                />
                { title }
              </button>
            </div>

            <div className="md-modal__content no-padd" style={modalStyles}>
              <div className={`md-modal__content-text ${calendarModal ? 'md-modal--calendar': ''}`}>
                { children }
              </div>
            </div>
          </div>
        </Modal>
      </Fragment>
    );
  }
}

export default BookingModal;